import AfricaBlockChainSlider from "../assets/africa-block-chain-slider.png";
import AIMSlider from "../assets/AIM-slider.png";
import BipocSlider from "../assets/bipoc-foundation-slider.png";
import StartupYMMSlider from "../assets/startupYMM-slider.png";
import UCBSlider from "../assets/UCB-slider.png";
import PrecisionSportscarSlider from "../assets/precision-sportscar-slider.png";

import GIZSlider from "../assets/HomepageRecentProjGIZ.png";
import CanalPlusSlider from "../assets/PortfolioCanalPlus.png";
import HamiltonCrescentSlider from "../assets/PortfolioHamiltonCrescentImage.png";
import AldeliaSlider from "../assets/PortfolioAldeliaImage.png";
import ATRSlider from "../assets/PortfolioATRImage.png";
import WatchReportSlider from "../assets/PortfolioWatchReportImage.png";
import YellowCardSlider from "../assets/PortfolioYellowCardImage.png";
import MasterNodedSlider from "../assets/PortfolioMasterNodedImage.png";
import BuckheadSlider from "../assets/PortfolioBuckheadImage.png";
import KeplerSlider from "../assets/PortfolioKeplerImage.png";

const SliderData = [
  {
    thumbnail: GIZSlider,
    titleSecondLine: "GIZ",
  },
  {
    thumbnail: CanalPlusSlider,
    titleFirstLine: "CANAL",
    titleSecondLine: "PLUS",
  },
  {
    thumbnail: HamiltonCrescentSlider,
    titleFirstLine: "HAMILTON",
    titleThirdLine: "CRESCENT",
  },
  {
    thumbnail: AldeliaSlider,
    titleFirstLine: "AL",
    titleSecondLine: "DE",
    titleThirdLine: "LIA",
  },
  {
    thumbnail: WatchReportSlider,
    titleFirstLine: "WATCH",
    titleSecondLine: "REPORT",
  },
  {
    thumbnail: YellowCardSlider,
    titleFirstLine: "YELLOW",
    titleSecondLine: "SPORTS",
  },
  {
    thumbnail: MasterNodedSlider,
    titleSecondLine: "MASTER",
    titleThirdLine: "NODED",
  },
  {
    thumbnail: BuckheadSlider,
    titleSecondLine: "BUCK",
    titleThirdLine: "HEAD",
  },
  {
    thumbnail: KeplerSlider,
    titleSecondLine: "KEPLER",
  },
];

export default SliderData;
